import CallToAction from "../common/CallToAction";
import Footer from "../common/footer/Footer";
import MobileMenu from "../common/header/MobileMenu";
import Partners from "../common/Partners";
import Header from "../common/header/DefaultHeader";
import ContactUsForm from "../common/ContactUsForm/ContactUsForm";
import React, { useEffect, useState } from "react";

import "./index.css";
import LivevoxChat from "../pdp/pdpComponents/LivevoxChat";
import { trackButtonClick, trackPageMount } from "@/utils/analytics";
import OtherLinkFooter from "../common/footer/OtherLinkFooter";
import NewFooter from "../common/footer/NewFooter";

const Index = () => {
  return (
    <>
      {/* <!-- Main Header Nav --> */}

      {/* <!-- Main Header Nav --> */}
      <Header />

      {/* <!--  Mobile Menu --> */}
      <MobileMenu />

      {/* <!-- Modal --> */}

      {/* <!-- Home Design --> */}

      {/* <!-- Checkout Offers --> */}

      {/* <!-- Recommended Properties --> */}
      <div className="contact-banner-container">
        <div className="contact-banner-content">
          <h1 className="contact-banner-text">Contact Us</h1>
        </div>
      </div>

      {/* <!-- Real estate auctions made easy --> */}
      <section className="contactUs-Form">
        <div className="container p200">
          <div className="row contact_us_wrapper">
            <div className="col-lg-6 contact_us_left">
              <div className="faqtxt text-start">
                <ul
                  className="right_choice_sub"
                  style={{ lineHeight: "24px", listStyleType: "disc" }}
                >
                  <li>
                    For general questions related to our website or the
                    <br /> bid/offer process, visit our{" "}
                    <span>
                      <a
                        href="/support"
                        style={{ color: "#118cf4", textDecoration: "none" }}
                        onClick={() => {
                          trackButtonClick({
                            eventName: "contact_us_faq_click",
                            eventSource: "Contact Us Page FAQ click",
                            eventCategory: "FAQ Click",
                          });
                        }}
                      >
                        FAQ
                      </a>
                    </span>{" "}
                    page.
                  </li>
                  <li>
                    Email us at{" "}
                    <a
                      href="mailto:customercare@hubzu.com"
                      // className="text-primary"
                      style={{ color: "#118cf4", textDecoration: "none" }}
                      onClick={() => {
                        trackButtonClick({
                          eventName: "contact_us_email_click",
                          eventSource: "Contact Us Page Email click",
                          eventCategory: "Email us Click",
                        });
                      }}
                    >
                      customercare@hubzu.com
                    </a>
                  </li>
                  <li>
                    <LivevoxChat
                      showContent={false}
                      showContentTitle={false}
                      contentText="Chat live with us"
                    />
                  </li>
                </ul>

                <div className="contactUsAvailability">
                  Hubzu Customer Care is available from 7 AM - 7 PM EDT
                  <br />
                  Mon-Fri and 12 PM - 5 PM EDT Sat &amp; Sun
                </div>
              </div>
            </div>
            <div className="col-lg-6 contact_us_right">
              <div className="">
                <ContactUsForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Wide range of properties --> */}

      {/* <!-- Mobile App Ads --> */}

      {/* <!-- milestones --> */}

      {/* <!-- Register --> */}

      {/* <!-- Our Partners --> */}

      {/* <!--Footer --> */}
      {/* <section className="footer_one home6 bg-ptrn2">
        <div className="container">
          <div className="row">
            <Footer />
          </div>
        </div>
      </section> */}
         <div className="container-fluid px-0">
                      {/* <Footer /> */}
                      <OtherLinkFooter/>
                      <NewFooter/>
                  </div>
      {/* <!-- Footer Bottom Area --> */}
    </>
  );
};

export default Index;
